<!--  -->
<template>
  <div class="add_box">
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="5">
          <el-input
            v-model.trim="query.keyword"
            placeholder="请输入广告主名称"
          >
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-col>
        <el-button type="primary" @click="menuList">搜索</el-button>
        <el-button
          type="primary"
          @click="resetTencentAdqAdverList"
        >重置</el-button>
      </el-row>
    </div>
    <el-table
      ref="table"
      v-loading="loading"
      :data="tableData"
      border
      row-key="account_id"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <el-table-column align="center" prop="id" label="id" />
      <el-table-column align="center" prop="account_id" label="广告主id" />
      <el-table-column
        align="center"
        prop="advertiser_name"
        label="广告主名称"
        width="300"
      />
    </el-table>

    <pagination-right
      :current-page="query.page"
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <div style="float: right; margin: 20px">
      <el-button type="primary" size="mini" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'

import {
  getAccountList
} from '@/api/massiveAdvertising/accountList.js'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      dialogVisible: false,
      total: null,
      adtype: null,
      query: {
        page: 1,
        page_size: 10,
        keyword: null
      },
      tableData: [],
      multipleSelection: [],
      loading: false
    }
  },
  created() {},
  mounted() {},
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    async menuList() {
      // 获取列表
      this.loading = true

      const data = await getAccountList(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      this.loading = false
    },
    resetTencentAdqAdverList() {
      this.query = {
        page: 1,
        page_size: 10,
        keyword: null
      }
      this.menuList()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.menuList()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.menuList()
    },
    updatawe() {
      this.dialogVisible = false
      this.menuList()
    },
    sendr(arr) {
      this.$refs.table.clearSelection()
      if (arr.length !== 0) {
        this.multipleSelection = arr
        arr.forEach((element) => {
          this.$refs.table.toggleRowSelection(element, true)
        })
      }

      this.menuList()
    },
    reset() {
      this.objr.page = 1
      this.objr.page_size = 10
      this.objr.keyword = null
      this.objr.status = null
      this.menuList()
    },
    submit() {
      this.$emit('bandarr', this.multipleSelection)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.add_box {
  padding: 20px;
}
.defaultrse {
  color: #e6a23c;
}
.defaultr {
  color: #67c23a;
}
.stopew {
  color: red;
}
.fasrw {
  color: #409eff;
}
.sarch_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.sedrtw {
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
.sedrtwr {
  width: 380px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 auto;
}
</style>
